import React from "react";

export function HeartGlyph({ size = 14 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor">
      <path d="M12 21s-7-4.5-9.5-9C.7 8.4 2.5 4 6.5 4c2 0 3.5 1 5.5 3 2-2 3.5-3 5.5-3 4 0 5.8 4.4 4 8-2.5 4.5-9.5 9-9.5 9z"/>
    </svg>
  );
}
export function ArrowGlyph() {
  return (
    <svg className="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}
export function AppleGlyph() {
  return (
    <svg width="14" height="16" viewBox="0 0 24 28" fill="currentColor">
      <path d="M17.5 14.6c0-3.4 2.8-5 2.9-5.1-1.6-2.3-4-2.6-4.9-2.7-2.1-.2-4 1.2-5.1 1.2-1.1 0-2.7-1.2-4.4-1.1-2.3 0-4.4 1.3-5.5 3.4-2.4 4.1-.6 10.2 1.7 13.5 1.1 1.6 2.5 3.4 4.2 3.4 1.7-.1 2.3-1.1 4.4-1.1 2 0 2.6 1.1 4.4 1 1.8 0 3-1.6 4.1-3.3 1.3-1.9 1.8-3.7 1.9-3.8-.1-.1-3.6-1.4-3.7-5.4zM14 4.6c.9-1.1 1.6-2.7 1.4-4.2-1.4.1-3 .9-4 2-.9 1-1.7 2.6-1.5 4.1 1.5.1 3.1-.8 4.1-1.9z"/>
    </svg>
  );
}
export function PlayGlyph() {
  return (
    <svg width="14" height="16" viewBox="0 0 24 28" fill="currentColor">
      <path d="M3 2l16 12L3 26z"/>
    </svg>
  );
}
export function PinGlyph() {
  return (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 22s7-7 7-13a7 7 0 1 0-14 0c0 6 7 13 7 13z"/>
      <circle cx="12" cy="9" r="2.5"/>
    </svg>
  );
}
export function CrossGlyph() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M6 6l12 12M18 6L6 18"/>
    </svg>
  );
}
export function StarGlyph() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2l2.9 6.9L22 10l-5.5 4.7L18 22l-6-3.6L6 22l1.5-7.3L2 10l7.1-1.1z"/>
    </svg>
  );
}
